import { useEffect, useState, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { ModalEstadoContext } from '../../contexts/ModalEstado'
import { MdViewKanban } from 'react-icons/md'
import { GoGoal } from "react-icons/go"
import { MdChecklist } from "react-icons/md"
import { BsFileEarmarkBarGraph } from "react-icons/bs"
import { FaRegUserCircle } from "react-icons/fa"
import MenuTarefas from '../MenuOpcoesTarefas'
import MenuOpcoesKanban from '../MenuOpcoesKanban'
import MenuOpcoesDesafios from '../MenuOpcoesDesafios'
import MenuOpcoesPlanoAcao from '../MenuOpcoesPlanoAcao'
import MenuOpcoesIndicadores from '../MenuOpcoesIndicadores'
import MenuSuporte from '../MenuOpcoesSuporte'
import Perfil from '../../middleware/Perfil'
import MenuOpcoesUsuarios from '../MenuOpcoesUsuarios'
import ModalMeuPerfil from '../ModalMeuPerfil'
import ModalAtualizarAvatarUsuario from '../ModalAtualizarAvatarUsuario'
import avatarDefault from '../../assets/img/avatarDefault.png'
import avatarOrganizacaoDefault from '../../assets/img/organizacao.png'
import logoImg from '../../assets/img/logo.png'
import tarefasIcone from '../../assets/icons/tarefas.svg'
import suporteImg from '../../assets/icons/suporte.svg'
import logoIcone from '../../assets/img/icone.png'
import './menulateral.css'
import { VscGraph } from "react-icons/vsc";
import MenuOpcoesDashboard from '../MenuOpcoesDashboard'

function MenuLateral() {

    const { search } = useLocation()
    const paramsUrl = new URLSearchParams(search)
    const grupo = paramsUrl.get("grupo");

    const navigate = useNavigate()

    const { modalExibir, exibirModalSecundario, modalEstadoSecundario, modal } = useContext(ModalEstadoContext)

    const [avatar, setAvatar] = useState('')
    const [avatarOrganizacao, setAvatarOrganizacao] = useState('')
    const [dadosUsuario, setDadosUsuario] = useState(false)
    const [modalPerfil, setModalPerfil] = useState(false)

    const exibirDadosUsuario = () => setDadosUsuario(!dadosUsuario)

    const exibirModalPerfil = () => exibirModalSecundario()

    const atualizarAvatarUsuario = () => {

        return modalExibir('atualizarAvatarUsuario')
    }

    const home = () => navigate('/')

    const sair = () => {


        localStorage.removeItem("perfilGesttor")
        localStorage.removeItem('usuarioGesttor')
        localStorage.removeItem("organizacaoGesttor")
        localStorage.removeItem("usuarioGesttorAvatar")
        localStorage.removeItem("organizacaoGesttorAvatar")
        localStorage.removeItem('authGesttor')
        localStorage.removeItem('usuarioProjeto')

        document.cookie = 'authGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'
        document.cookie = 'modulosGesttor= ; expires=true, 01 Jan 2023 00:00:01 GMT'

        navigate("/auth")

        return;
    }


    useEffect(() => {
        setModalPerfil(modalEstadoSecundario)
    }, [modalEstadoSecundario])


    useEffect(() => {

        const avatar = () => {

            const avatarImg = localStorage.getItem('usuarioGesttorAvatar')

            if (avatarImg === 'null' || avatarImg === null) {

                return setAvatar(avatarDefault)
            }

            return setAvatar(avatarImg)
        }

        avatar()
    }, [])

    useEffect(() => {

        const avatarOrganizacao = () => {

            const avatarOrganizacaoImg = localStorage.getItem('organizacaoGesttorAvatar')

            if (avatarOrganizacaoImg === 'null' || avatarOrganizacaoImg === null) {

                return setAvatarOrganizacao(avatarOrganizacaoDefault)
            }

            return setAvatarOrganizacao(avatarOrganizacaoImg)
        }

        avatarOrganizacao()

    }, [])

    return (
        <>
            {modalPerfil && <ModalMeuPerfil />}
            {modal.nome === 'atualizarAvatarUsuario' && <ModalAtualizarAvatarUsuario />}
            <aside id='menuLateral'>
                <section id='logoGesttor'>
                    <img id='logoSistemaGesttorMenuLateralExpandido' src={logoImg} alt='logo do sistema gesttor' onClick={() => home()} />
                    <img id='logoSistemaGesttorMenuLateralRecolhido' src={logoIcone} alt='logo do sistema gesttor' onClick={() => home()} />
                </section >
                <section id='menuLateralOpcoes'>
                    {(grupo === "Gestão Financeira") ? (
                        <MenuOpcoesDashboard icone={<VscGraph id="iconeMenu" />} titulo='Dashboard' alt='' />
                    ) : null}
                    {(grupo === "Gestão Financeira" || grupo === "Gestão de Pessoas" || grupo === "Outros") ? (
                        <MenuOpcoesDesafios icone={<GoGoal id="iconeMenu" />} titulo='Desafios' alt='' />
                    ) : null}
                    {(grupo === "Gestão Financeira" || grupo === "Gestão de Pessoas" || grupo === "Outros") ? (
                        <MenuOpcoesPlanoAcao icone={<MdChecklist id="iconeMenu" />} titulo='Plano de Ação' alt='' />
                    ) : null}
                    <MenuTarefas icone={tarefasIcone} titulo='Tarefas' alt='' />
                    {(grupo === "Desenvolvimento de Software" || grupo === "Outros") ? (
                        <MenuOpcoesKanban icone={<MdViewKanban id="iconeMenu" />} titulo='Kanban' alt='' />
                    ) : null}
                    {(grupo === "Gestão Financeira" || grupo === "Gestão de Pessoas" || grupo === "Outros") ? (
                        <MenuOpcoesIndicadores icone={<BsFileEarmarkBarGraph id="iconeMenu" />} titulo='Indicadores' alt='' />
                    ) : null}
                    <Perfil perfil={["master", "consultor"]}>
                        <MenuOpcoesUsuarios icone={<FaRegUserCircle id="iconeMenu" />} titulo='Usuarios' alt='' />
                    </Perfil>
                    <MenuSuporte icone={suporteImg} titulo='Suporte' alt='' />
                </section>
                <section id='contaUsuarioMenu'>
                    <img id='avatarUsuarioGesttor' src={avatar} alt='' onClick={exibirDadosUsuario} />
                    <img id='avatarOrganizacaoGesttor' src={avatarOrganizacao} alt='' title='Empresa que você está trabalhando atualmente' />
                    <p onClick={exibirDadosUsuario}>Minha Conta</p>
                    {dadosUsuario && <span id='dadosUsarioMenulateral'>
                        <p onClick={() => exibirModalPerfil()}>Meu Perfil</p>
                        <p onClick={() => atualizarAvatarUsuario()}>Atualizar Avatar</p>
                        <p onClick={sair}>Sair</p>
                    </span>}
                </section>
            </aside>
        </>
    )
}

export default MenuLateral